import {
  AccidentsReportsAreaRoutes,
  DisruptionsAreaRoutes,
} from '@backoffice-frontend/common'
import { FleetMaintenanceAreaRoutes } from '@backoffice-frontend/fleet-maintenance'
import { RioCategory } from '@backoffice-frontend/graphql'
import { VehicleAreaRoutes } from '@backoffice-frontend/vehicle'
import { BoumRight } from '@moia-dev/moia-token-claims'
import type { TFunction } from 'i18next'

export type CategoryConfig = {
  rights: {
    write: BoumRight[]
    read: BoumRight[]
    delete: BoumRight[]
    assignee: BoumRight[]
  }
  routes: { list: string; view: string; notFound: string }
}

const accidentConfig = {
  rights: {
    write: [BoumRight.REPORT_ACCIDENT_CRUD],
    read: [BoumRight.REPORT_ACCIDENT_CRUD, BoumRight.REPORT_ACCIDENT_R],
    delete: [BoumRight.REPORT_ACCIDENT_CRUD],
    assignee: [],
  },
  routes: {
    list: AccidentsReportsAreaRoutes.route,
    view: AccidentsReportsAreaRoutes.ViewReport.route,
    notFound: AccidentsReportsAreaRoutes.NotFound.route,
  },
}

const vehicleChecksConfig = {
  rights: {
    write: [BoumRight.REPORT_VEHICLE_CHECK_CRUD],
    read: [
      BoumRight.REPORT_VEHICLE_CHECK_CRUD,
      BoumRight.REPORT_VEHICLE_CHECK_R,
    ],
    delete: [BoumRight.REPORT_VEHICLE_CHECK_CRUD],
    assignee: [],
  },
  routes: {
    list: VehicleAreaRoutes.RideChecks.route,
    view: VehicleAreaRoutes.RideChecksView.route,
    notFound: VehicleAreaRoutes.RideChecksNotFound.route,
  },
}

const disruptionConfig = {
  rights: {
    write: [
      BoumRight.REPORT_DISRUPTION_CRUD,
      BoumRight.REPORT_ASSIGNEE_DISRUPTION_CRU,
    ],
    read: [
      BoumRight.REPORT_DISRUPTION_CRUD,
      BoumRight.REPORT_ASSIGNEE_DISRUPTION_CRU,
      BoumRight.REPORT_DISRUPTION_R,
    ],
    delete: [BoumRight.REPORT_DISRUPTION_CRUD],
    assignee: [BoumRight.REPORT_ASSIGNEE_DISRUPTION_CRU],
  },
  routes: {
    list: DisruptionsAreaRoutes.route,
    view: DisruptionsAreaRoutes.ViewReport.route,
    notFound: DisruptionsAreaRoutes.NotFound.route,
  },
}

const damageReportsConfig = {
  rights: {
    write: [BoumRight.REPORT_DAMAGE_CRUD],
    read: [BoumRight.REPORT_DAMAGE_CRUD, BoumRight.REPORT_DAMAGE_R],
    delete: [BoumRight.REPORT_DAMAGE_CRUD],
    assignee: [],
  },
  routes: {
    list: FleetMaintenanceAreaRoutes.Damages,
    view: FleetMaintenanceAreaRoutes.DamagesViewReport,
    notFound: FleetMaintenanceAreaRoutes.DamagesNotFound,
  },
}

export const getCategoryConfig: (category: RioCategory) => CategoryConfig = (
  category: RioCategory,
) => {
  switch (category) {
    case RioCategory.Accident:
      return accidentConfig
    case RioCategory.VehicleChecks:
      return vehicleChecksConfig
    case RioCategory.Disruption:
      return disruptionConfig
    case RioCategory.DamageReport:
      return damageReportsConfig

    default:
      throw new Error(`Unknown category ${category}`)
  }
}

export const listViewNavigationLabel = (
  category: RioCategory,
  t: TFunction,
) => {
  switch (category) {
    case RioCategory.Accident:
      return t('reportIOLib_navigation_accidents')
    case RioCategory.VehicleChecks:
      return t('reportIOLib_navigation_vehicle_checks')
    case RioCategory.Disruption:
      return t('reportIOLib_navigation_disruptions')
    case RioCategory.DamageReport:
      return t('reportIOLib_navigation_damage_reports')
    default:
      return ''
  }
}
